import Vue from 'vue'
import VueRouter, {RouteConfig} from 'vue-router'
import store from '@/store';
import Authorization from "@/authorization/authorization";
import Cognito from "@/cognito/cognito";
import RoutingBehavior from "@/router/routing_behavior";

Vue.use(VueRouter)

const routes: Array<RouteConfig> = [
  {
    path: '/',
    name: 'dashboard',
    component: () => import('@/views/console/Dashboard.vue'),
    meta:{
      title: 'ダッシュボード',
      tab:'dashboard',
    }
  },
  {
    path: '/applications',
    name: 'applications',
    component: () => import('@/views/console/Applications.vue'),
    meta:{
      title: 'アプリケーション一覧',
      tab:'application',
    }
  },
  {
    path: '/applications/:sid',
    name: 'application',
    component: () => import('@/views/console/Applications.vue'),
    meta:{
      title: 'アプリケーション',
      tab:'application',
    }
  },
  {
    path: '/numbers',
    name: 'numbers',
    component: () => import('@/views/console/Numbers.vue'),
    meta:{
      title: '電話番号一覧',
      tab:'number',
    }
  },
  {
    path: '/numbers/:sid',
    name: 'number',
    component: () => import('@/views/console/Numbers.vue'),
    meta:{
      title: '電話番号詳細',
      tab:'number',
    }
  },
  {
    path: '/logs',
    name: 'logs',
    component: () => import('@/views/console/Logs.vue'),
    meta:{
      title: 'ログ',
      tab:'log',
    }
  },
  {
    path: '/profile',
    name: 'profile',
    component: () => import('@/views/console/Accounts.vue'),
    meta:{
      title: 'アカウント',
      tab:'account',
    }
  },
  {
    path: '/logout',
    name: 'logout',
    component: () => import('@/views/console/Logout.vue'),
    meta:{
      isPublic:true,
      title: 'ログアウト'
    }
  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router

router.beforeEach((to, from, next) => {
  // isPublic でない場合(=認証が必要な場合)、かつ、ログインしていない場合
  const auth = new Authorization();
  const routing = new RoutingBehavior(to);

  if (routing.doLogout(Vue.$cookies.get(String(process.env.VUE_APP_COOKIE_BEARER_TOKEN)))) {
    next(routing.getNextQuery());
  }
  auth.getInitialize(Vue.$cookies.get(String(process.env.VUE_APP_COOKIE_BEARER_TOKEN)))
      .then(response => {
        console.log(response.data);
        Vue.$cookies.set(String(process.env.VUE_APP_COOKIE_ACCOUNT_ID), response.data.account.id);
        next();
      }).catch(error => {
    if (error.response.status === 403 && !routing.isPublic()) {
      const cognito = new Cognito();
      cognito.refresh(
          Vue.$cookies.get(String(process.env.VUE_APP_COOKIE_COGNITO_USER_NAME)),
          Vue.$cookies.get(String(process.env.VUE_APP_COOKIE_REFRESH_TOKEN))
      ).then(response => {
        console.log(response);
        Vue.$cookies.set(String(process.env.VUE_APP_COOKIE_BEARER_TOKEN), response.accessToken.getJwtToken());
        next(routing.getNextQuery());
      }).catch(error => {
        console.log(error.response);
        routing.doLogout(null);
        next(routing.getNextQuery());
      });
      return;
    }
    location.href = String(process.env.VUE_APP_LOCATION_AUTH_PAGE);
  });
});

router.afterEach((to,from) => {
  from;
  if (to.meta && to.meta.title) {
    store.dispatch('title/changePage', to.meta.title)
  }
  if(to.meta && to.meta.tab){
    store.dispatch('tab/changeTab', to.meta.tab)
  }
})